import Html from './html.vue';
export default Html;


// WEBPACK FOOTER //
// ./src/components/html/index.js